import React, {Component} from 'react';
import { connect } from "react-redux"
import Form from '../Components/Form';
import FormResults from '../Components/FormResults';
import { host } from '../config';

import './FormContainer.css';
import { evtTrack } from '../utils/analytics';
import { updateWheelPrize, updateSpinStatus, wheelSpinning } from '../actions/wheel';

class FormContainer extends Component{

  constructor(props) {
    super(props);

    this.defaultStatus = 0;
    this.storageName = 'christmas';
    this.entryPointValue = 'christmas';
    this.apiUrl = '/api/v1/christmas';

    this.state = {
      status: this.defaultStatus,
      result: null,
      error: null,
      data: {},
      showResults: false,
      prize: null,
      doneSpinning: false
      // doneSpinning: true
    }

    this.formSubmit = this.formSubmit.bind(this);
  }

  formSubmit(jsonData) {

    // const iteratePrize = this.state.prize === null || this.state.prize >= (this.prizes.length - 1) ? 0 : this.state.prize + 1;
    // this.setState({prize: iteratePrize});

    evtTrack('25daysofchristmas2020-sweeps-form-submit');

    const json = Object.assign({}, jsonData);

    if (json.phoneNumber && json.agreeText) {
      json['mobileNumber'] = json.phoneNumber;
      json['entryPoint'] = this.entryPointValue;
      fetch(host + this.apiUrl + '/text-subscribe', {
        method: 'POST',
        body: JSON.stringify(json)
      })
      .then(resp=>resp.json)
      .then(data=>console.log('st:',data));
    }

    fetch(host + this.apiUrl + '/save-entry', {
      method: 'POST',
      body: JSON.stringify(json),
    })
    .then((response) => {
      this.setState({status: response.status});

      return response.json();
    })
    .then((result) => {
      console.log('fetch results:', result);

      this.setState({
        error: result.error || this.state.error,
        result, 
        data:json, 
        showResults: !(result.error && result.error.field),
        prize: result.success || null
      });

      window.localStorage.setItem(this.storageName,JSON.stringify(json));
    })
    .catch((error) => {
      this.setState({result: error, data:json});
    });

  }

  renderForm() {

    const {
      status,
      result,
      data,
      error,
      showResults
    } = this.state;

    // const showResults=true, status=200, result={success:'prize-giftbox'}, data={}, error=''; //Testing FormResults

    if (showResults) {
      return <FormResults 
                status={status} 
                message={result}
                data={data}
                />
    }
    
    return <Form
      handleSubmit={this.formSubmit}
      submitError={error}
      data={data}
      />
  }

  componentDidMount() {
    const data = JSON.parse(window.localStorage.getItem(this.storageName)) || this.state.data;
    this.setState({data});
  }

  componentDidUpdate(prevProps, prevState) {
    
    if (this.state.prize !== null && prevState.prize !== this.state.prize) {
      // this.props.updateWheelPrize(this.prizes[this.state.prize]);
      this.props.updateWheelPrize(this.state.prize);
    }

    //wheel finished spinning
    if (this.props.debugAllowed && prevProps.spinning && prevProps.spinning !== this.props.spinning) {

      //test email reset prize to allow multiple spins
      if (/(_m|_d)@gsn.com$/.test(this.state.data.email)) {
        this.setState({
          showResults: false,
          prize: null
        });
      }
    }

    if (prevProps.spinning && !this.props.spinning) {
      this.setState({
        doneSpinning: true
      });
    }
  }

  render() {
    return (
      <div id="form-container" className={"form-container" + (this.state.doneSpinning ? ' done-spinning' : '')}>
        { this.renderForm() }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  spun: state.s_wheel.spun,
  spinning: state.s_wheel.spinning,
  debugAllowed: state.debugAllowed
});

const mapDispatchToProps = dispatch => ({
  updateWheelPrize: data => {
    dispatch(updateWheelPrize(data));
  },
  updateSpinStatus: data => {
    dispatch(updateSpinStatus(data));
  },
  wheelSpinning: data => {
    dispatch(wheelSpinning(data));
  },
});;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormContainer)